export default "__VITE_ASSET__DGrZSUAe__"